import React from "react";

const Stats = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        {/* Header Section */}
        <div style={styles.header}>
          <h2 style={styles.heading}>Our Expertise</h2>
          <div style={styles.underline}></div>
          <p style={styles.subtext}>
            Navigating crypto can feel overwhelming. We simplify the journey and
            help you make confident, informed decisions in a rapidly evolving
            market.
          </p>
        </div>

        {/* Cards Grid */}
        <div style={styles.cardGrid}>
          {[
            {
              icon: "📊",
              title: "Investment Strategy",
              text: "We create simple and effective investment plans based on your goals. Whether you want short-term profits or long-term growth, we guide you step by step.",
            },
            {
              icon: "🔐",
              title: "Security & Protection",
              text: "Crypto frauds are increasing every day. We help you protect your funds, avoid scams, and secure your wallets with proven safety methods.",
            },
            {
              icon: "🚀",
              title: "Growth & Advisory",
              text: "We don't just guide you grow with us. From portfolio management to market insights, we help you build strong and profitable crypto assets.",
            },
          ].map((item, index) => (
            <div key={index} style={styles.card}>
              <div style={styles.iconBox}>{item.icon}</div>
              <h3 style={styles.cardTitle}>{item.title}</h3>
              <p style={styles.cardText}>{item.text}</p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div style={styles.statsSection}>
          <h3 style={styles.statsHeading}>Trust the Numbers</h3>
          <div style={styles.statsRow}>
            {[
              { label: "Years of Experience", value: "6+" },
              { label: "Clients Worldwide", value: "500+" },
              { label: "Strategic Partners", value: "15" },
            ].map((stat, index) => (
              <div key={index} style={styles.statItem}>
                <h2 style={styles.number}>{stat.value}</h2>
                <p style={styles.statLabel}>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "50px 20px",
    background:
      "radial-gradient(circle at top left, #1e3a8a, #0f172a, #581c87)",
    color: "#f8fafc",
    fontFamily: "'Inter', sans-serif",
    overflow: "hidden",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
  },
  header: {
    textAlign: "center",
    marginBottom: "60px",
  },
  heading: {
    fontSize: "clamp(32px, 5vw, 48px)",
    fontWeight: "800",
    letterSpacing: "-0.02em",
    marginBottom: "16px",
  },
  underline: {
    width: "60px",
    height: "4px",
    background: "#9333ea",
    margin: "0 auto 24px",
    borderRadius: "2px",
  },
  subtext: {
    maxWidth: "640px",
    margin: "0 auto",
    fontSize: "18px",
    color: "#cbd5e1",
    lineHeight: "1.7",
  },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "30px",
    marginBottom: "80px",
  },
  card: {
    background: "rgba(255, 255, 255, 0.03)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    padding: "40px 30px",
    borderRadius: "24px",
    transition: "transform 0.3s ease, border-color 0.3s ease",
    cursor: "default",
  },
  iconBox: {
    fontSize: "40px",
    marginBottom: "20px",
    background: "rgba(147, 51, 234, 0.1)",
    width: "70px",
    height: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "16px",
  },
  cardTitle: {
    fontSize: "22px",
    fontWeight: "700",
    marginBottom: "12px",
    color: "#fff",
  },
  cardText: {
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#94a3b8",
  },
  statsSection: {
    textAlign: "center",
    padding: "60px 0",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
  },
  statsHeading: {
    fontSize: "20px",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: "#9333ea",
    marginBottom: "40px",
    fontWeight: "600",
  },
  statsRow: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    gap: "40px",
  },
  statItem: {
    flex: "1 1 200px",
  },
  number: {
    fontSize: "48px",
    fontWeight: "800",
    marginBottom: "8px",
    background: "linear-gradient(to bottom, #fff, #94a3b8)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  statLabel: {
    fontSize: "16px",
    color: "#64748b",
    fontWeight: "500",
  },
};

export default Stats;
